import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export const SHELL_DESTINATIONS = [
    { value: 'today', label: 'Today', mobileNav: true },
    { value: 'strategies', label: 'Strategies', mobileNav: true },
    { value: 'trade', label: 'Trade', mobileNav: true },
    { value: 'platform', label: 'Platform', mobileNav: true },
    { value: 'more', label: 'More', mobileNav: true, mobileOnly: true },
    { value: 'research', label: 'Research', desktopExtended: true },
    { value: 'admin', label: 'Admin', desktopExtended: true },
    { value: 'docs', label: 'Docs', desktopExtended: true },
];

const DEFAULT_DESTINATION = SHELL_DESTINATIONS[0].value;

const ShellNavContext = createContext({
    destination: DEFAULT_DESTINATION,
    subTab: null,
    setDestination: () => {},
    setSubTab: () => {},
});

export const ShellNavProvider = ({ children }) => {
    const [destination, setDestinationState] = useState(DEFAULT_DESTINATION);
    const [subTab, setSubTabState] = useState(null);

    const setDestination = useCallback((nextDestination, nextSubTab = null) => {
        setDestinationState(nextDestination);
        setSubTabState(nextSubTab);
    }, []);

    const setSubTab = useCallback((nextSubTab) => {
        setSubTabState(nextSubTab);
    }, []);

    const value = useMemo(
        () => ({
            destination,
            subTab,
            setDestination,
            setSubTab,
        }),
        [destination, subTab, setDestination, setSubTab]
    );

    return <ShellNavContext.Provider value={value}>{children}</ShellNavContext.Provider>;
};

export const useShellNav = () => useContext(ShellNavContext);

export const getDestinationLabel = (destination) =>
    SHELL_DESTINATIONS.find((item) => item.value === destination)?.label || destination;
